import { Link } from 'gatsby';
import React, { useState } from 'react';
import { convertResourceCategoryToPageSlug } from 'src/functions/resourceCategoryToSlug';
import CloseIcon from 'src/app_previous/images/CloseIcon';
import ChevronWhiteMobile from 'src/app_previous/images/sliders/chevron.white.mobile';
import {
  ResouceCenterMobileMenuOverlay,
  ResourceCenterMobileMenuContainer,
  ResourceCenterMobileMenuLink,
  ResourceCenterMobileMenuLinkOverflow,
  ResourceCenterMobileMenuPost,
  ResourceCenterMobileCloseButton,
} from './Menu.mobile.styles';

interface ResourceCenterMobileMenuProps {
  opened: boolean;
  onOverlayClick: () => void;
  links: { [key: string]: { [key: string]: { title: string; slug: string }[] } };
}

const ResourceCenterMobileMenu = ({ opened, links, onOverlayClick }: ResourceCenterMobileMenuProps): JSX.Element => {
  const [categorySelected, setCategorySelected] = useState('');
  const [subcategorySelected, setSubcategorySelected] = useState('');

  const selectCategory = (category: string) => () => {
    setCategorySelected((currentCategory) => (currentCategory === category ? '' : category));
  };

  const selectSubCategory = (subcategory: string) => () => {
    setSubcategorySelected((currentSubCategory) => (currentSubCategory === subcategory ? '' : subcategory));
  };

  return (
    <>
      <ResourceCenterMobileMenuContainer style={{ transform: `translateX(-${opened ? '0' : '100'}vw)` }}>
        {Object.keys(links)
          .sort((a, b) => a.localeCompare(b))
          .map((category) => {
            const categoryGroup = links[category];
            const categoryActive = categorySelected === category;
            const subCategoryEntriesDisplayed = Object.keys(categoryGroup).length;
            const postEntriesDisplayed = !categoryGroup[subcategorySelected]
              ? 0
              : categoryGroup[subcategorySelected].length;
            return (
              <ResourceCenterMobileMenuLink
                key={category}
                active={categoryActive}
                extendable={true}
              >
                <Link to={`/resources/${convertResourceCategoryToPageSlug(category)}`}>{category}</Link>
                <div onClick={selectCategory(category)} />
                <span onClick={selectCategory(category)}>
                  <ChevronWhiteMobile
                    height={14}
                    orientation={categoryActive ? 'down' : 'up'}
                  />
                </span>
                <ResourceCenterMobileMenuLinkOverflow
                  style={{
                    maxHeight: categoryActive
                      ? `${(subCategoryEntriesDisplayed + postEntriesDisplayed) * 150}px`
                      : '0px',
                  }}
                >
                  {Object.keys(categoryGroup)
                    .sort((a, b) => a.localeCompare(b))
                    .map((subcategory) => {
                      const subcategoryActive = subcategorySelected === subcategory;
                      return (
                        <ResourceCenterMobileMenuLink
                          key={subcategory}
                          active={subcategoryActive}
                          extendable={true}
                        >
                          <Link
                            to={`/resources/${convertResourceCategoryToPageSlug(
                              category
                            )}/${convertResourceCategoryToPageSlug(subcategory)}`}
                          >
                            {subcategory}
                          </Link>
                          <div onClick={selectSubCategory(subcategory)} />
                          <span onClick={selectSubCategory(subcategory)}>
                            <ChevronWhiteMobile
                              height={14}
                              orientation={subcategoryActive ? 'down' : 'up'}
                            />
                          </span>
                          <ResourceCenterMobileMenuLinkOverflow
                            style={{
                              maxHeight: subcategoryActive
                                ? `${(subCategoryEntriesDisplayed + postEntriesDisplayed) * 150}px`
                                : '0px',
                            }}
                          >
                            {categoryGroup[subcategory].map((post) => (
                              <ResourceCenterMobileMenuPost key={post.slug}>
                                <Link to={`/resources/${post.slug}`}>{post.title}</Link>
                              </ResourceCenterMobileMenuPost>
                            ))}
                          </ResourceCenterMobileMenuLinkOverflow>
                        </ResourceCenterMobileMenuLink>
                      );
                    })}
                </ResourceCenterMobileMenuLinkOverflow>
              </ResourceCenterMobileMenuLink>
            );
          })}
      </ResourceCenterMobileMenuContainer>
      <ResouceCenterMobileMenuOverlay
        opened={opened}
        onClick={onOverlayClick}
      >
        <ResourceCenterMobileCloseButton>
          <CloseIcon />
        </ResourceCenterMobileCloseButton>
      </ResouceCenterMobileMenuOverlay>
    </>
  );
};

export default ResourceCenterMobileMenu;
